import { request, requestToken } from "../api/request_methods";

const API_BASE = `${process.env.REACT_APP_NODE_URL}/api/place-bets`;

class PlaceBetServices {
  /**
   * GET place bet detail by placebet_uid (public, no auth – for QR scan view)
   */
  async getPlaceBetByUid(uid) {
    if (!uid || !String(uid).trim()) throw new Error("UID required");
    const encoded = encodeURIComponent(String(uid).trim());
    const response = await request.get(`${API_BASE}/view-by-uid/${encoded}`);
    return response;
  }
  /**
   * GET list with filters
   * @param {Object} params - search, game_type, filter_type, from_date, to_date, page, limit
   */
  async getPlaceBetList(params = {}) {
    const sp = new URLSearchParams();
    if (params.search) sp.set("search", params.search);
    if (params.game_type) sp.set("game_type", params.game_type);
    if (params.filter_type) sp.set("filter_type", params.filter_type);
    if (params.from_date) sp.set("from_date", params.from_date);
    if (params.to_date) sp.set("to_date", params.to_date);
    if (params.userId) sp.set("userId", String(params.userId));
    if (params.page) sp.set("page", String(params.page));
    if (params.limit) sp.set("limit", String(params.limit));
    const url = `${API_BASE}?${sp.toString()}`;
    const response = await requestToken.get(url);
    return response;
  }

  async getPlaceBetListForExport({
    search,
    game_type,
    filter_type,
    from_date,
    to_date,
    userId,
  }) {
    const limit = 100;
    let page = 1;
    let allData = [];
    let totalPages = 1;
    do {
      const res = await this.getPlaceBetList({
        search: search || undefined,
        game_type: game_type || undefined,
        filter_type: filter_type || undefined,
        from_date: from_date || undefined,
        to_date: to_date || undefined,
        userId: userId || undefined,
        page,
        limit,
      });
      if (res?.isSuccess === false) throw new Error(res?.message || "Failed to fetch");
      allData = allData.concat(res?.data || []);
      totalPages = res?.pagination?.totalPages || 1;
      page++;
    } while (page <= totalPages);
    return allData;
  }

  /**
   * GET single place bet detail by id
   */
  async getPlaceBetById(id) {
    const response = await requestToken.get(`${API_BASE}/${id}`);
    return response;
  }

  /**
   * GET place bet id by bar_code OR placebet_uid (safe, no scan).
   */
  async getPlaceBetIdByCode(code) {
    if (!code || !String(code).trim()) throw new Error("Code required");
    const encoded = encodeURIComponent(String(code).trim());
    const response = await requestToken.get(`${API_BASE}/id-by-code/${encoded}`);
    return response;
  }
}

export default PlaceBetServices;
